export const ADD_TAB = 'ADD_TAB';
export const UPDATE_TAB = 'UPDATE_TAB';
export const DELETE_TAB = 'DELETE_TAB';
export const CANCEL_ADD_TAB = 'CANCEL_ADD_TAB';
export const ADD_CREATED_TAB = 'ADD_CREATED_TAB';
export const SORT_ITEMS = 'SORT_ITEMS';
export const RESET_TABS = 'RESET_TABS';
export const SAVE_SORTED_TABS = 'SAVE_SORTED_TABS';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SHOW_HIDE_ALL_TABS = 'SHOW_HIDE_ALL_TABS';
export const SHOW_HIDE_TAB = 'SHOW_HIDE_TAB';
export const SET_PROJECT_DATA = 'SET_PROJECT_DATA';
